import { JogId, Jog, AgencyId, Agency } from ".";
import Agencies from "./agencies";

const isUserJog = true;
const notIsUserJog = !isUserJog;
const isGroupOnly = true;
const isFilter = true;
const notIsFilter = !isFilter;

const makeJog = (id: JogId, name: string, shortName: string, isFilter = true, isUserJog = true, isGroupOnly = false): Jog => {
  return {
    id,
    name,
    shortName,
    agencies: getJogAgencies(id, Agencies),
    isFilter,
    isUserJog,
    isGroupOnly,
  }
}

const agencyJogsMap = new Map<AgencyId, Set<JogId>>();

// todo: jcavner: there's a potential for an issue here
// todo: look at usages of this, check if issue remains
export const getAgencyJogIds = (id: AgencyId): Set<JogId> | undefined => {
  return  agencyJogsMap.get(id);
}

const getJogAgencies = (jogId: JogId, agencies: Agency[]): Agency[] => {
  const jogAgencies: Agency[] = [];
  agencies.forEach((agency) => {
    if (agency.jogId === jogId) {
      // Add to JOG's agencies
      jogAgencies.push(agency);
      
      // Add to agencyJogsMap
      let set = agencyJogsMap.get(agency.id);
      if(set) {
        set.add(agency.jogId);
      } else {
        agencyJogsMap.set(agency.id, new Set([agency.jogId]));
      }      
    }
  })

  return jogAgencies;
}

export const Jogs: Jog[] = [
  makeJog(JogId.Other, "Other/Unassigned", "Other", notIsFilter, notIsUserJog),
  
  // "Participating"
  makeJog(JogId.ClarkCounty, "Clark County JOG", "Clark Co."),
  makeJog(JogId.JBLM, "Joint Base Lewis-McChord JOG", "JBLM"),
  makeJog(JogId.KingCountyNortheast, "Northeast King County JOG", "NEJOG"),
  makeJog(JogId.KingCountySouth, "South King County JOG", "South JOG"),
  makeJog(JogId.KitsapPeninsula, "Kitsap Peninsula JOG", "Kitsap Pen."),
  makeJog(JogId.LowerColumbiaRiver, "Lower Columbia River JOG", "Lower Col. River"),
  makeJog(JogId.NorthwestWashington, "Northwest WA JOG", "NW WA"),
  makeJog(JogId.SeattleArea, "Seattle Area JOG", "SAJOG"),
  makeJog(JogId.SnohomishCounty, "Snohomish County JOG", "Snohomish Co."),
  makeJog(JogId.Tacoma, "Tacoma JOG", "Tacoma"),

  // "Group" (not an actual JOG)
  makeJog(JogId.EasternWashington, "Eastern WA Group", "Eastern WA", isFilter, isUserJog, isGroupOnly), // Temp group for areas covered by WSP districts 3, 4, 6. Not a JOG. // todo: jcavner: verify it's on notifications preferences page. Actually, we're not going to create incidents so it doesn't need to be there for launch
  makeJog(JogId.Wsp, "Washington State Patrol Districts", "WSP Districts", isFilter, notIsUserJog, isGroupOnly),
]

// eslint-disable-next-line
const futureJogs: Jog[] = [
  // Not finalized
  //makeJog(JogId.CowlitzCounty, "Cowlitz County JOG", "Cowlitz Co.", notIsFilter, notIsUserJog),
  // makeJog(JogId.ThurstonCounty, "Thurston County JOG", "Thurston Co.", notIsFilter, notIsUserJog),
  makeJog(JogId.TriCities, "Tri-Cities JOG", "Tri-Cities", notIsFilter, notIsUserJog),
  makeJog(JogId.LewisCounty, "Lewis County JOG", "Lewis Co.", notIsFilter, notIsUserJog),
  makeJog(JogId.Spokane, "Spokane JOG", "Spokane", notIsFilter, notIsUserJog),
]

const setJogMap = (): Map<string, Jog> => {
  let jogMap = new Map<string, Jog>();
  Jogs.forEach((jog) => {
    jogMap.set(jog.id, jog)
  })

  return jogMap;
}

export const JogMap = setJogMap();
// todo: create GetJog function ?
